// @ts-nocheck

import { useNavigate } from "react-router-dom";
import React, { useCallback, useRef, useState } from "react";
import { useEffect } from "react";
import PopupOtp from "components/popup-otp";
import PopupNoGift from "components/popup-no-gift";
import PopupGiftTopup from "components/popup-gift-topup";
import PopupMessage from "components/popup-message";
import * as htmlToImage from "html-to-image";
import Select from "react-select";
import moment from "moment";

import html2canvas from "html2canvas";
import PopupDownloadImg from "components/PopupDownloadImg";
import { frameList } from "constants/common";
// import * as styles from "./styles.module.scss";
// import {bgs, than,btn1, btn2, btn3 } from "assets/img"
const InformationPageView = (props) => {
  const {
    genderSelected,
    setGenderSelected,
    isDisableInput,
    onChangeDate,
    valueDate,
    setBirthDay,
    setShowModalBirthday,
    showModalBirthday,
    setClearBirthday,
    birthError,
    setBirthError,
    setIsShowModalWhishNote,
    setIsShowModalSuccessNote,
    wishContent,
    songLinkRef,
    songName,
    statusSong,
    playSong,
    setImageUrl,
    frameName,
  } = props;
  const navigate = useNavigate();
  let wish = localStorage.getItem("wish");

  const downloadRef = useRef();
  const [imgData, setImgData] = useState(null);
  const [isOpenDownloadImg, setIsOpenDownloadImg] = useState(false);
  const exportAsImage = async (el, imageFileName) => {
    const canvas = await html2canvas(el);
    const image = canvas.toDataURL("image/png", 1.0);
    setImgData(image);
    setIsOpenDownloadImg(true);
    // downloadImage(image, imageFileName);
  };
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      playSong("paused");
    } else {
      // audio.play();
    }
  });

  const downloadImage = (blob, fileName) => {
    const fakeLink = window.document.createElement("a");
    fakeLink.style = "display:none;";
    fakeLink.download = fileName;

    fakeLink.href = blob;

    document.body.appendChild(fakeLink);
    fakeLink.click();
    document.body.removeChild(fakeLink);

    fakeLink.remove();
  };

  const handleChangeValue = (key, value) => {
    if (!key || !value) return;

    onChangeDate(value);

    props.setValue("birthday", moment(value).format("YYYY-MM-DD").toString());
    const today = new Date();
    let date = new Date(value);
    setBirthError(false);
    if (date.getTime() > today.getTime()) {
      console.log("birth====", date.getTime(), today.getTime());
      setBirthError(true);
      props.setValue("isAgree", false);
    } else {
      setBirthError(false);
    }

    // if (today < birth) {
    //   setBirthError(true);

    //   console.log("birth====", birthError);
    // } else {
    //   setBirthError(false);

    //   console.log("birth====", birthError);
    // }
  };
  const clearDate = () => {
    // props.setValue("birthday", "");
    // onChangeDate("");
    // console.log("birthday====", valueDate);

    setBirthError(false);
    props.setValue("isAgree", false);
    onChangeDate();
  };

  const showModalSaveNote = () => {
    setIsShowModalWhishNote(true);
  };
  const showModalSuccessNote = () => {
    setIsShowModalSuccessNote(true);
  };

  useEffect(() => {
    console.log("valueDate", valueDate);
    if (valueDate !== undefined) {
      props.setValue(
        "birthday",
        moment(valueDate).format("YYYY-MM-DD").toString()
      );
    } else {
      props.setValue("birthday", "");
    }
  }, [valueDate]);
  return (
    <section>
      <PopupDownloadImg
        isOpenDownloadImg={isOpenDownloadImg}
        srcImg={imgData}
        setIsOpenDownloadImg={setIsOpenDownloadImg}
      />
      <div className="bgr-green">
        <div className="group-flex container preview-wish-step">
          <img className="gift-item-1" src="assets/img/gift-item-4.png" alt="" />
          <img className="gift-item-2" src="assets/img/gift-item-3.png" alt="" />

          <img className="img-full" src="assets/img/line-4.png" alt="line-bt" />
          <div className="bgr-wishnote">
            <div
              className="wishnote-inner"
              ref={downloadRef}
              onClick={() => {
                exportAsImage(downloadRef.current, "test");
              }}
            >
              <img src={`/assets/img/${frameName}`} />
              <div className="content">
                <p
                  className="wish-content"
                  dangerouslySetInnerHTML={{ __html: wishContent }}
                ></p>
              </div>
            </div>

            <div className="music-block">
              <div className="item-music">
                <img
                  className={
                    statusSong === "play" ? "i-music run" : "i-music pause"
                  }
                  src="assets/img/imusic.png"
                  alt=" "
                />
                <div>
                  <h4>{songName}</h4>
                  {statusSong === "play" && (
                    <img class src="assets/img/music.gif" alt=" " />
                  )}
                </div>
              </div>
              <img
                onClick={() =>
                  playSong(statusSong === "play" ? "paused" : "play")
                }
                className="i-pause"
                src={
                  statusSong === "play"
                    ? "assets/img/pause.png"
                    : "assets/img/play_arrow.png"
                }
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default InformationPageView;
